import 'react-multi-carousel/lib/styles.css'

import React, { useEffect, useRef, useState } from 'react'

import img from 'assets/images/distributionPage/Partners/stage-5.png'
import video from 'assets/images/distributionPage/Partners/stage5.mp4'
import classNames from 'classnames'
import Carousel from 'react-multi-carousel'
import { defaultCarouselProps, Video } from 'shared/components'
import { useIntersection, useWindowSize } from 'shared/hooks'
import { playVideo } from 'shared/utils'
import { detectDevice } from 'shared/utils/detectDevice'
import carouselClasses from 'styles/carousel.module.scss'

import { subscriberItems } from './items'
import classes from './Subscribers.module.scss'

export const Subscribers = (): JSX.Element => {
  const carouselprops = defaultCarouselProps(false, {
    largeDesktop: 6,
    mediumDesktop: 4,
    desktop: 3,
    tablet: 3,
  })
  const ref = useRef<HTMLVideoElement>(null)
  const [titleRef, titleRefEntry] = useIntersection({})
  const [isPlayed, setIsPlayed] = useState<boolean>(false)
  const { isTablet, isMobile } = useWindowSize()
  const isTabletDevice = detectDevice()

  useEffect(() => {
    if (titleRefEntry?.isIntersecting && !isPlayed) {
      setIsPlayed(true)
      playVideo(ref.current)
    }
    return () => {}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleRefEntry])
  const renderTablet = () => (
    <img className={classes.tabletImg} src={img} alt="" />
  )

  const cn = classNames([
    classes.container,
    'container',
    {
      [classes.offset]: isTabletDevice || isMobile,
    },
  ])
  return (
    <div className={cn}>
      <h2 className={`${classes.title} second-title`}>
        <span
          ref={titleRef}
          className="reveal-from-bottom"
          data-reveal-delay={50}
        >
          СПОСОБЫ ПРИВЛЕЧЕНИЯ ПОДПИСЧИКОВ
        </span>
        <Video
          videoRef={ref}
          className={classes.video}
          src={video}
          childTablet={renderTablet}
        />
      </h2>
      <div
        className={`${classes['carousel-container']} reveal-from-bottom-medium`}
        data-reveal-delay={50}
      >
        <Carousel
          {...carouselprops}
          showDots={isTablet || isMobile}
          dotListClass={carouselClasses.dotList}
          containerClass={`${classes.carousel__row} row`}
          itemClass={`${classes.carousel__item} col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-2`}
        >
          {subscriberItems.map((item, itemIndex) => (
            <div key={itemIndex} className={classes.item}>
              <h3 className={classes['item--title']}>{item.title}</h3>
              <small className={classes['item--descr']}>{item.descr}</small>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}
